import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'vue';
import 'deepmerge';
import plugctr from '@ecis/plugctr';
import Cookies from 'js-cookie';
import zhCNUi from './lang/zh-CN.js';

/**
 * @description 对文案插值，根据 i18n 官方，应支持以下两种写法
 * @example 数组写法，列表格式
 * schema: '确认授予{0}【{1}】权限？'
 * usage: t('xxx', ['a', 'b'])
 * @example 对象写法，具名格式
 * schema: '确认授予{user}【{permission}】权限？'
 * usage: t('xxx', { user: 'a', permission: 'b' })
 * 以上例子均应得到相同结果，即：'确认授予a【b】权限？'
 *
 * corner case：若缺少插值参数（空字符串不算缺少），应保留占位符
 *
 * @param {string} schema
 * @param {Array | object | undefined} interpolations
 * @returns {string}
 */
function interpolate(schema, interpolations) {
  if (!interpolations) {
    return schema;
  }
  return schema === null || schema === void 0 ? void 0 : schema.replace(/{[^{|}]+}/g, function (match) {
    var key = match.replace(/{|}/g, '');
    return interpolations[key];
  });
}

var DEFAULT_LANG = 'zh-CN';
var DEFAULT_MESSAGES = function DEFAULT_MESSAGES(lang) {
  if (lang === 'zh-CN') {
    return zhCNUi;
  }
  if (lang === 'en-US') {
    return function () {
      return import('./lang/en-US.js');
    };
  }
  if (lang === 'zh-HK') {
    return function () {
      return import('./lang/zh-HK.js');
    };
  }
  if (lang === 'ja') {
    return function () {
      return import('./lang/ja.js');
    };
  }
  return zhCNUi;
};
var lang = DEFAULT_MESSAGES(getClientLocale());
_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var _yield$lang, defaultVal;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        if (!(typeof lang === 'function')) {
          _context.next = 6;
          break;
        }
        _context.next = 3;
        return lang();
      case 3:
        _yield$lang = _context.sent;
        defaultVal = _yield$lang["default"];
        lang = defaultVal;
      case 6:
      case "end":
        return _context.stop();
    }
  }, _callee);
}))();
var use = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$lang2, defaultVal;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          lang = DEFAULT_MESSAGES(getClientLocale());
          if (!(typeof lang === 'function')) {
            _context2.next = 7;
            break;
          }
          _context2.next = 4;
          return lang();
        case 4:
          _yield$lang2 = _context2.sent;
          defaultVal = _yield$lang2["default"];
          lang = defaultVal;
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function use() {
    return _ref2.apply(this, arguments);
  };
}();
var i18n = function i18n(fn) {
};

/**
 * @description 支持占位符传参
 * @param {string} path
 * @param {Array | object | undefined} interpolations
 * @returns {string}
 */
var t = function t(path, interpolations) {
  /**
   * @param {object} value
   * @param {string} path
   * @returns {string | undefined} undefined
   */
  var finder = function finder(value, path) {
    return path.split('.').reduce(function (prev, key) {
      return prev ? prev[key] : undefined;
    }, value);
  };

  // 找不到时回退到中文
  var schema = finder(lang, path) || finder(zhCNUi, path) || '';
  // 处理占位符
  var text = interpolate(schema, interpolations);
  // 定制 ECIS
  var rtrData = plugctr.ask('translate', {
    key: path,
    text: text
  });
  if (rtrData == null) {
    return text;
  }
  return rtrData;
};

/**
 * @description 多语言lang -> i18n messages key 映射，比如 'zh' -> 'zh-CN'
 * @param {VueI18n.Locale} lang
 * @typedef {'zh-CN' |'en-US'} Returns
 */
function flex() {
  var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'zh';
  var majorcode = lang.toLowerCase().slice(0, 2);
  switch (majorcode) {
    case 'en':
      return 'en-US';
    case 'zh':
      if (lang.toLowerCase() === 'zh-hk') {
        return 'zh-HK';
      }
      return 'zh-CN';
    case 'ja':
      return 'ja';
    default:
      return 'zh-CN';
  }
}
function getClientLocale() {
  // 优先级 url query: cookie > default lang
  var lang = Cookies.get('lang') || DEFAULT_LANG;
  return flex(lang);
}
var index = {
  use: use,
  t: t,
  i18n: i18n
};

export { index as default, getClientLocale, i18n, t, use };
